import React from 'react';
import { useI18n } from '@/lib/i18n';

/**
 * Discreet footer with TSTT copyright and small icon.
 * Visible on all main pages (not on KDS fullscreen).
 */
export function AppFooter() {
  const { lang } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer
      className="border-t border-[hsl(var(--border))] py-3 px-4 mt-6 text-center text-[10px] text-[hsl(var(--muted-foreground))] tracking-wide"
      data-testid="app-footer"
    >
      <a
        href="https://www.tstt.com.br"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 hover:text-[hsl(var(--foreground))] transition-colors group"
        data-testid="footer-tstt-link"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="11"
          height="11"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="opacity-60 group-hover:opacity-100 transition-opacity"
        >
          <rect x="3" y="3" width="18" height="18" rx="3" />
          <path d="M7 8h10" />
          <path d="M12 8v9" />
        </svg>
        <span>© {year} www.tstt.com.br</span>
      </a>
    </footer>
  );
}
